import React from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';
import Layout from '../../components/Layout/Layout';
import './Contacts.css';

const Contacts = () => {
  return (
    <Layout>
      <main className="contacts-page">
        <section className="contacts-panel">
          <h1>Contacts</h1>
          <div className="contact-methods">
            <div className="contact-method">
              <Phone size={22} />
              <div>
                <h2>Phone</h2>
                <a href="tel:+14242495973">(424) 249-5973</a>
              </div>
            </div>

            <div className="contact-method">
              <Mail size={22} />
              <div>
                <h2>Email</h2>
                <a href="mailto:support@snagitcheap.com">support@snagitcheap.com</a>
              </div>
            </div>

            <div className="contact-method">
              <MapPin size={22} />
              <div>
                <h2>Service Area</h2>
                <p>United States</p>
              </div>
            </div>
          </div>
        </section>

        <section className="contacts-note">
          <h2>Before You Order</h2>
          <p>
            Contact us with product questions, delivery questions, or condition questions before checkout.
            Include the product name or SKU so we can look it up quickly.
          </p>
        </section>
      </main>
    </Layout>
  );
};

export default Contacts;
